import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { IconButton, Tooltip, Modal, Box } from '@mui/material';


function ExpenseIndex() {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {

        fetchtableData();

    }, []);


    const fetchtableData = async () => {

        fetchData('ExpenseApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Details:', error);
            });


    };



    const handleDelete = async () => {
        deleteData('ExpenseApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (itemId) => {
        activateData('ExpenseApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleCreateNewClick = (page) => {
        history.push(`/${page}`);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ textTransform: 'uppercase', color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                    Expense
                </h6>
                {hasCreateTransactionPermission && (
                    <Button
                        component={Link}
                        to="/ExpenseCreate"
                        className="linkcolor"
                        style={{
                            marginRight: '8px',
                            background: 'linear-gradient(to right, darkslategray, slategray)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',

                        }}
                    >
                        CREATE NEW
                    </Button>
                )}
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>

                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Bill Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Account Head</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {data.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.BillNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.AccountHeadName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.Amount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '13px' }}>
                                        <Link to={`/CustomerEdit/${item.id}`}>
                                            <Tooltip title="Edit Customer">
                                                <IconButton>
                                                    <EditIcon style={{ color: 'red' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>

                                        <Tooltip title="Delete Customer">
                                            <IconButton onClick={() => openConfirmDialog(item.id)}>
                                                <DeleteIcon style={{ color: 'brown' }} />
                                            </IconButton>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        {/* Delete confirmation dialog */}
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default ExpenseIndex;

